import { styled } from "../../styled-components";

export const ColumnListContainer = styled.div<{ outerPadding: number }>`
    display: flex;

    padding: 0 ${p => p.outerPadding / 2}px;
`;

export const ColumnItemPlaceholder = styled.div`
    flex: 50%;
    flex-shrink: 1;

    min-width: 1px;
`;
